import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { Routing, AppRoutingProviders } from './app.routing';
import { AppComponent } from './app.component';
import { CitLicenceGeneratorComponent } from './cit-licence-generator/cit-licence-generator.component';
import { HttpClientHelperService } from './core/http-client-helper.service';
import { CitLicenseGeneratorService } from './cit-licence-generator/cit-license-generator.service';
import { CitHelpService } from './cit-help/cit-help.service';
import { CitGlobalConstantService } from './core/cit-global-constants.service'
import { OnlyNumber } from "./shared/cit-numberonly.directive";
import { CITHelpComponent } from "./cit-help/cit-help.component";
import { GCSLoadingSpinnerComponent } from "./shared/loadingspinner/gcs-loading-spinner.component"
@NgModule({ declarations: [
        AppComponent,
        CitLicenceGeneratorComponent,
        CITHelpComponent,
        OnlyNumber,
        GCSLoadingSpinnerComponent
    ],
    bootstrap: [AppComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        BrowserModule,
        Routing], providers: [
        HttpClientHelperService,
        CitGlobalConstantService,
        CitLicenseGeneratorService,
        CitHelpService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
